import * as z from "zod"
import { contentStatuses, contentTypeNames, supportedContentLocales } from "./core"

export const contentLocaleSchema = z.enum(supportedContentLocales)
export const contentStatusSchema = z.enum(contentStatuses)
export const contentTypeNameSchema = z.enum(contentTypeNames)

export const localizedTextSchema = z.object({
  en: z.string().optional(),
  ja: z.string().optional(),
})

export const cmsAssetSchema = z
  .object({
    id: z.string().optional(),
    objectKey: z.string().min(1),
    mimeType: z.string().optional(),
    width: z.number().int().positive().optional(),
    height: z.number().int().positive().optional(),
  })
  .strict()

export const cmsContentVersionSchema = z
  .object({
    id: z.string().optional(),
    contentItemId: z.string().optional(),
    contentType: contentTypeNameSchema,
    status: contentStatusSchema,
    locale: contentLocaleSchema,
    slug: z.string().optional(),
    title: z.string().optional(),
    publishedAt: z.string().optional(),
    revision: z.number().int().positive().default(1),
  })
  .strict()

export type LocalizedText = z.infer<typeof localizedTextSchema>
export type CmsAsset = z.infer<typeof cmsAssetSchema>
export type CmsContentVersion = z.infer<typeof cmsContentVersionSchema>
